import Future from 'fluture'
import axios from 'axios'
import {fetchUrlBasedOnEnv} from '../../util/helpers'
import {path} from 'ramda'

export const changeActiveTab = (data) => {
  return {
    type: 'CHANGE_TAB',
    data,
  }
}

export const getAccessCountries = () => ({apis}) => {
  const payload = apis.getAccessCountries().map((x) => x)
  return {
    type: 'GET_COUNTRIES',
    payload,
  }
}
export const getUserDetails = (getUserAccessActions) => ({apis, getState}) => {
  Future.encaseP2(axios.get)(`${fetchUrlBasedOnEnv()}/monitoring/user/details`, apis.getGlobalHeaderConfig())
    .map(path(['data']))
    .fork(() => {}, getUserAccessActions)
  const payload = null
  return {
    type: 'GET_USER_DETAILS',
    payload,
  }
}
export const getUserAccessActions = (data) => ({apis, getState}) => {
  const csUserId = data && data[0].csUserId
  const payload = apis.getUserAccess(csUserId).map((x) => x)
  return {
    type: 'GET_USER_ACCESS',
    csUserId,
    payload,
  }
}
export const setInfoObject = (data) => {
  return {
    type: 'SET_INFO_OBJ',
    data,
  }
}

export const resetInfoObject = (data) => {
  return {
    type: 'RESET_INFO_OBJ',
  }
}



// WEBPACK FOOTER //
// ./src/store/app/actions.js